import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Radio, FormControlLabel } from '@material-ui/core';

const ComponentStyled = styled(FormControlLabel)`
  .MuiButtonBase-root {
    margin-right: 4px;
  }
  &,
  .MuiRadio-root {
    color: ${({ theme }) => theme.colors.white} !important;
  }
  &.MuiFormControlLabel-root {
    margin-bottom: 0;
  }
`;

const RadioButton = ({ label, ...props }) => {
  return (
    <ComponentStyled
      control={
        // https://material-ui.com/api/radio/
        <Radio {...props} />
      }
      label={label}
    />
  );
};

RadioButton.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

export default RadioButton;
